"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _common = require("../utils/common");
var _initLoadSdk = require("../utils/initLoadSdk");
var _log = _interopRequireDefault(require("../utils/log"));
// 生命周期设计文档https://dashen.zhuanspirit.com/pages/viewpage.action?pageId=470189267

var EVENTS = ['visibilitychange', 'pageshow', 'replaceState', 'pushState', 'popstate', 'pagehide', 'beforeunload'];

// 定义支持状态的枚举类型
var SupportStatus; // 初始化为未知状态
(function (SupportStatus) {
  SupportStatus["UNKNOWN"] = "unknown";
  SupportStatus["SUPPORTED"] = "supported";
  SupportStatus["UNSUPPORTED"] = "unsupported";
})(SupportStatus || (SupportStatus = {}));
var support = SupportStatus.UNKNOWN;
var wrapHistoryFn = function wrapHistoryFn(fnName) {
  var originFn = window.history[fnName];
  return function () {
    var ret = originFn.apply(this, arguments);
    var event = new Event(fnName);
    event.arguments = arguments;
    window.dispatchEvent(event);
    return ret;
  };
};
var getPageUrl = function getPageUrl() {
  try {
    if (typeof window === 'undefined') return '';
    var _window$location = window.location,
      hostname = _window$location.hostname,
      pathname = _window$location.pathname,
      hash = _window$location.hash;
    var url = hostname + pathname + "".concat(hash && hash.split('?')[0]);
    return url;
  } catch (e) {
    console.log(e);
  }
};
var getCallbackParam = function getCallbackParam(type, href) {
  try {
    if (!href) {
      href = getPageUrl();
    }
    href = encodeURIComponent(href);
    var time = new Date().getTime();
    return {
      type: type,
      href: href,
      time: time
    };
  } catch (e) {
    _log.default.error('getCallbackParam' + e);
  }
};

// 返回当前的url
function getPath() {
  return location.href;
}
var PageLife = /*#__PURE__*/function () {
  function PageLife() {
    var _this = this;
    (0, _classCallCheck2.default)(this, PageLife);
    (0, _defineProperty2.default)(this, "oldPath", void 0);
    (0, _defineProperty2.default)(this, "supportNative", void 0);
    (0, _defineProperty2.default)(this, "zzJsSdk", void 0);
    (0, _defineProperty2.default)(this, "initNativeEvent", function () {
      _this.zzJsSdk["onShow"]({}, function (res) {
        if (res && res.code == 0) {
          // if (res.isFirstShow) {
          _this.wrapHandle(function () {
            _log.default.info('lego生命周期执行onLoad');
            PageLife.onLoad();
          });
          _this.wrapHandle(function () {
            _log.default.info('lego生命周期执行onShow');
            PageLife.onShow();
          });
        }
      });
      _this.zzJsSdk["onHide"]({}, function (res) {
        if (res && res.code == 0) {
          _this.wrapHandle(function () {
            _log.default.info('lego生命周期执行onHide');
            PageLife.onHide();
          });
        }
      });
    });
    (0, _defineProperty2.default)(this, "handleEvents", function (evt) {
      switch (evt.type) {
        case "pageshow":
          if (!_this.supportNative || !_this.zzJsSdk) {
            _this.wrapHandle(function () {
              _log.default.info('lego生命周期执行onLoad');
              PageLife.onLoad();
              _log.default.info('lego生命周期执行onShow');
              PageLife.onShow();
            });
          }
          break;
        case "visibilitychange":
          if (!_this.supportNative || !_this.zzJsSdk) {
            if (document.visibilityState === "visible") {
              _log.default.info('lego生命周期执行onShow');
              PageLife.onShow();
            } else {
              _log.default.info('lego生命周期执行onHide');
              PageLife.onHide();
            }
          }
          break;
        case "pagehide":
          if (!_this.supportNative || !_this.zzJsSdk) {
            _this.wrapHandle(function () {
              if (!(0, _common.isiOS)()) {
                _log.default.info('lego生命周期执行onHide');
                PageLife.onHide();
                _log.default.info('lego生命周期执行onUnload');
                PageLife.onUnload();
              }
            });
          }
          break;
        case "beforeunload":
          if (!_this.supportNative || !_this.zzJsSdk) {
            _this.wrapHandle(function () {
              if ((0, _common.isiOS)()) {
                _log.default.info('lego生命周期执行onHide');
                PageLife.onHide();
                _log.default.info('lego生命周期执行onUnload');
                PageLife.onUnload();
              }
            });
          }
        case "popstate":
        case "pushState":
        case "replaceState":
          _this.wrapHandle(function (from, to) {
            if (from != to) {
              _log.default.info('lego生命周期执行onHide');
              PageLife.onHide();
              _log.default.info('lego生命周期执行onLoad');
              PageLife.onLoad();
              _log.default.info('lego生命周期执行onShow');
              PageLife.onShow();
            }
          });
          break;
      }
    });
    (0, _defineProperty2.default)(this, "add", function (type, callback) {
      var hook = type + 'Fns';
      if (Array.isArray(PageLife[hook])) {
        if (!PageLife[hook].includes(callback)) {
          PageLife[hook].push(callback);
        }
      }
    });
    this.init();
    _log.default.info('lego生命周期初始化成功');
  }
  // 初始化sdk
  (0, _createClass2.default)(PageLife, [{
    key: "initSdk",
    value: function () {
      var _initSdk = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this2 = this;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve) {
                try {
                  if (window.__ZZAPP__) {
                    _this2.zzJsSdk = window.__ZZAPP__;
                    _log.default.info('lego需要的sdk已经加载，zzJsSdk全局变量获取成功');
                    resolve(true);
                  } else {
                    (0, _common.loadJS)(_initLoadSdk.zzsdk, function () {
                      _this2.zzJsSdk = window.__ZZAPP__;
                      _log.default.info('lego加载sdk成功');
                      resolve(true);
                    });
                  }
                } catch (error) {
                  _log.default.warn('lego加载sdk不成功');
                  resolve(true);
                }
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function initSdk() {
        return _initSdk.apply(this, arguments);
      }
      return initSdk;
    }()
  }, {
    key: "checkSdkSupport",
    value: function () {
      var _checkSdkSupport = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(method) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(support !== SupportStatus.UNKNOWN)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", support === SupportStatus.SUPPORTED);
            case 2:
              if (!(window && (window.zhuanzhuanMApplication || window.zhuanzhuanMApplicationIos))) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return", new Promise(function (resolve) {
                window.__ZZAPP__.hasSupportFeature({
                  method: method
                }, function (res) {
                  if (res && res.code === '1') {
                    support = SupportStatus.SUPPORTED;
                    resolve(true);
                  } else {
                    support = SupportStatus.UNSUPPORTED;
                    resolve(false);
                  }
                });
              }));
            case 6:
              support = SupportStatus.UNSUPPORTED;
              return _context2.abrupt("return", false);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function checkSdkSupport(_x) {
        return _checkSdkSupport.apply(this, arguments);
      }
      return checkSdkSupport;
    }() // 初始化
  }, {
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _this3 = this;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return this.initSdk();
            case 3:
              _context3.next = 5;
              return this.checkSdkSupport('registerLifecycleEventShow');
            case 5:
              this.supportNative = _context3.sent;
              if (this.supportNative) {
                if (this.zzJsSdk) {
                  this.initNativeEvent();
                }
              }
              // 存储旧的url
              this.oldPath = getPath();

              // 自定义监听 pushState replaceState
              this.swizzleHistoryMethods();

              // 为所有枚举的事件添加事件处理回调
              EVENTS.forEach(function (eventType) {
                return addEventListener(eventType, _this3.handleEvents, true);
              });
              _context3.next = 15;
              break;
            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](0);
              _log.default.error(_context3.t0);
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 12]]);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "swizzleHistoryMethods",
    value: function swizzleHistoryMethods() {
      window.history.pushState = wrapHistoryFn("pushState");
      window.history.replaceState = wrapHistoryFn("replaceState");
    }
    // 处理枚举的事件
  }, {
    key: "wrapHandle",
    value: function wrapHandle(callback) {
      var from = this.oldPath;
      var to = getPath();
      callback(from, to);
      this.oldPath = to;
    }
  }, {
    key: "removeListener",
    value: function removeListener() {
      var _this4 = this;
      EVENTS.forEach(function (evt) {
        return removeEventListener(evt, _this4.handleEvents, true);
      });
    }
  }]);
  return PageLife;
}();
(0, _defineProperty2.default)(PageLife, "onShowFns", []);
(0, _defineProperty2.default)(PageLife, "onHideFns", []);
(0, _defineProperty2.default)(PageLife, "onLoadFns", []);
(0, _defineProperty2.default)(PageLife, "onUnloadFns", []);
(0, _defineProperty2.default)(PageLife, "onShow", function () {
  var param = getCallbackParam('onShow', getPageUrl());
  Array.isArray(PageLife.onShowFns) && PageLife.onShowFns.forEach(function (fn) {
    return fn(param);
  });
  // 每次页面变动的时候，清空找靓机backup备份的参数
  window['getLegoBackUpParam'] = '';
});
(0, _defineProperty2.default)(PageLife, "onHide", function () {
  var param = getCallbackParam('onHide', getPageUrl());
  Array.isArray(PageLife.onHideFns) && PageLife.onHideFns.forEach(function (fn) {
    return fn(param);
  });
});
(0, _defineProperty2.default)(PageLife, "onLoad", function () {
  var param = getCallbackParam('onLoad', getPageUrl());
  Array.isArray(PageLife.onLoadFns) && PageLife.onLoadFns.forEach(function (fn) {
    return fn(param);
  });
});
(0, _defineProperty2.default)(PageLife, "onUnload", function () {
  var param = getCallbackParam('onLoad', getPageUrl());
  Array.isArray(PageLife.onUnloadFns) && PageLife.onUnloadFns.forEach(function (fn) {
    return fn(param);
  });
});
var _default = new PageLife();
exports.default = _default;